/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ usage: NonNullable<unknown> }} Dashboard_Billing_Usage_This_PeriodInputs */



/**
* | output |
* | --- |
* | "Usage this period {usage}" |
*
* @param {Dashboard_Billing_Usage_This_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_usage_this_period = /** @type {((inputs: Dashboard_Billing_Usage_This_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Usage_This_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nutzung in dieser Periode ${i?.usage}`)
	return /** @type {LocalizedString} */ (`Usage this period ${i?.usage}`)
});